import { api } from "./api";
import {
  ITherapistActivityReportRequest,
  ITherapistActivityReportResponse,
} from "../types/periodicReports.types";

export const periodicReportsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTherapistActivityReport: build.mutation<
      ITherapistActivityReportResponse,
      ITherapistActivityReportRequest
    >({
      query: (body) => ({
        url: "/Admintech/Admin_TherapistActivityReport",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useGetTherapistActivityReportMutation } = periodicReportsApi;
